import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ContentService } from 'src/app/views/content/content.service';

@Component({
  selector: 'app-content-change-dialog',
  templateUrl: './content-change-dialog.component.html',
  styleUrls: ['./content-change-dialog.component.scss'],
  standalone: false,
})
export class ContentChangeDialogComponent implements OnInit {
  courses = [];
  selectedCourse;
  result = [];
  query = '';
  constructor(
    private contentService: ContentService,
    private dialogRef: MatDialogRef<ContentChangeDialogComponent>
  ) {}

  ngOnInit() {
    this.getCourses();
  }

  performSearch() {
    this.result = this.courses.filter((course) => course?.name?.includes(this.query));
  }

  getCourses() {
    this.contentService.getAllCourses().subscribe((courses) => {
      this.courses = courses || [];
      this.performSearch();
    });
  }

  selectCourse(course) {
    this.selectedCourse = course;
  }

  selectContent(section, lecture) {
    this.dialogRef.close({ course: this.selectedCourse, section, lecture });
  }
}
